/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { Logout, AuthPage, useAuth } from '../modules/auth'
// import {FrontPage} from '../modules/front'
import { App } from '../App'
import { Thanking } from '../modules/auth/components/Thanking'
import DealPage from '../pages/Global/DealPage'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const { currentUser } = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
              <Route path = '/deal/:dealno' element={<DealPage/>} />
            </>
          ) : (
            <>
              <Route path='dashboard' element={<Navigate to='/auth' />} />
              <Route path='/*' element={<Navigate to='/auth' />} />
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='thankyou' element={<Thanking />} />
              <Route path='*' element={<Navigate to='/auth' />} />
              <Route path = '/deal/:dealno' element={<DealPage/>} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
